import api from '@/api';

import { API_BASE_URL } from '..';
import { PageRequest } from '@/core/request/PageRequest';
import {
  DeleteMultipleInvoiceItems,
  InvoiceItemList,
  InvoiceItemUpdateTaxesRequest,
} from './invoiceItem.types';

const CONTROLLER_URL = `${API_BASE_URL}/invoices/items`;

export async function updateInvoiceItemCfop(obj: {
  invoiceId: number;
  cfopId?: number;
}) {
  const result = (await api.put(
    `${CONTROLLER_URL}/invoice/${obj.invoiceId}/cfop/${obj.cfopId}`,
    {},
    null,
  )) as unknown;

  return result as void;
}

export async function updateInvoiceItemRate(obj: {
  invoiceId: number;
  rate?: number;
}) {
  const result = (await api.put(
    `${CONTROLLER_URL}/invoice/${obj.invoiceId}/rate/${obj.rate}`,
    {},
    null,
  )) as unknown;

  return result as void;
}

export async function updateInvoiceItemTaxes({
  invoiceId,
  ...obj
}: InvoiceItemUpdateTaxesRequest) {
  const result = (await api.put(
    `${CONTROLLER_URL}/invoice/${invoiceId}/taxes`,
    obj,
    null,
  )) as unknown;

  return result as void;
}

export async function listInvoiceItem(
  params: PageRequest & { invoiceId?: number },
) {
  const result = (await api.get(
    `${CONTROLLER_URL}/invoice/${params.invoiceId}`,
    params,
  )) as unknown;

  return result as InvoiceItemList[];
}

export async function calculateItemTaxes(itemId?: number) {
  const result = (await api.post(
    `${CONTROLLER_URL}/${itemId}`,
    {},
    null,
  )) as unknown;

  return result as void;
}

export async function deleteMultipleInvoiceItems(
  data: DeleteMultipleInvoiceItems,
) {
  return (await api.remove(
    `${CONTROLLER_URL}/batch`,
    { ...data },
    null,
  )) as unknown;
}
